import { useEffect, useState } from 'react';

export const useCurrentTime = () => {
    const [currentTime, setCurrentTime] = useState(() => new Date());

    useEffect(() => {
        const timeout = setTimeout(
            () => {
                setCurrentTime(new Date());
            },
            1000 + currentTime.getTime() - Date.now(),
        );

        return () => {
            clearTimeout(timeout);
        };
    });

    return currentTime;
};
